import { render, staticRenderFns } from "./modal_receita_carbonara.vue?vue&type=template&id=1ab1c25e&scoped=true"
import script from "./modal_receita_carbonara.vue?vue&type=script&lang=js"
export * from "./modal_receita_carbonara.vue?vue&type=script&lang=js"
import style0 from "./modal_receita_carbonara.vue?vue&type=style&index=0&id=1ab1c25e&prod&scoped=true&lang=css"
import style1 from "./modal_receita_carbonara.vue?vue&type=style&index=1&id=1ab1c25e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab1c25e",
  null
  
)

export default component.exports